export const MESSAGES_MOCKED = [
  [
    {
      id: "10e18baa-87a6-4a27-9464-6d65855c826c",
      creation_timestamp: "2025-04-01T12:40:39.798239Z",
      role: "user",
      content: "test",
      file_name: null,
      file_type: null,
    },
    {
      id: "2103518a-1389-4b0a-b471-b363ca689607",
      creation_timestamp: "2025-04-01T12:40:48.306436Z",
      role: "assistant",
      content: "Hello! How can I assist you today?",
      file_name: null,
      file_type: null,
    },
    {
      id: "1e196dab-cd68-4e8f-9461-999bf778c9e6",
      creation_timestamp: "2025-04-02T21:57:54.107054Z",
      role: "user",
      content: "Give quote of the day",
      file_name: null,
      file_type: null,
    },
    {
      id: "bca75902-92c0-482f-9d49-a8c68b3ac1c3",
      creation_timestamp: "2025-04-02T21:58:03.302239Z",
      role: "assistant",
      content:
        "Sure! Here's an inspirational quote for you:\n\n*\"The future depends on what you do today.\"* – Mahatma Gandhi\n\nLet me know if there's anything else I can help with! 🙂",
      file_name: null,
      file_type: null,
    },
    {
      id: "8c3b043b-e790-4abe-a4b2-ae5b49f8997b",
      creation_timestamp: "2025-04-02T21:58:34.261373Z",
      role: "user",
      content: "what is answer to everything?",
      file_name: null,
      file_type: null,
    },
    {
      id: "e1a7faa1-1cdd-4ba7-882b-a3c000fa827d",
      creation_timestamp: "2025-04-02T21:58:42.275503Z",
      role: "assistant",
      content:
        "Ah, you must be referencing *The Hitchhiker's Guide to the Galaxy* by Douglas Adams! According to the book, the answer to the ultimate question of life, the universe, and everything is **42**. 😄 \n\nOf course, the actual question remains unknown! Let me know if you'd like help with anything else. 🌌",
      file_name: null,
      file_type: null,
    },
    {
      id: "2b7a043a-92cd-4057-a93e-14e4c237ce2a",
      creation_timestamp: "2025-04-02T22:00:52.595058Z",
      role: "user",
      content: "What is area 42?",
      file_name: "Area 42.pdf",
      file_type: "application/pdf",
    },
    {
      id: "2c950b1f-deac-4878-bf0b-19588b8a1f18",
      creation_timestamp: "2025-04-02T22:01:02.514532Z",
      role: "assistant",
      content:
        "The term \"Area 42\" isn't universally recognized and could have many interpretations depending on the context. If you're referring to something specific (like a physical location, a fictional reference, or a company's term), could you clarify or provide more context? I'd be happy to assist further!",
      file_name: null,
      file_type: null,
    },
    {
      id: "2b7a043a-92cd-4057-a93e-14e4c237ce2a",
      creation_timestamp: "2025-04-02T22:00:52.595058Z",
      role: "user",
      content: "Best movies in 2012 from kazaa",
      file_name: "best movies.xlsx",
      file_type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
    {
      id: "2c950b1f-deac-4878-bf0b-19588b8a1f18",
      creation_timestamp: "2025-04-02T22:01:02.514532Z",
      role: "assistant",
      content: "The Dictator, Project X, Madagascar 3: Europe’s Most Wanted\n",
      file_name: null,
      file_type: null,
    },
  ],
  [
    {
      id: "664f2dc8-6add-4db4-b8a6-d90bde1059f6",
      creation_timestamp: "2025-04-01T08:48:03.776460Z",
      role: "user",
      content: "test",
      file_name: null,
      file_type: null,
    },
    {
      id: "553ce77d-2b06-4310-b92d-0f8a3acdc625",
      creation_timestamp: "2025-04-01T08:48:11.289538Z",
      role: "assistant",
      content: "Hello! How can I assist you today?",
      file_name: null,
      file_type: null,
    },
    {
      id: "802f1d56-985b-4bd4-b0d2-d49fe1bda869",
      creation_timestamp: "2025-04-02T22:20:06.637670Z",
      role: "user",
      content: "what is most popular music type",
      file_name: null,
      file_type: null,
    },
    {
      id: "b94eb783-3a18-4d38-9fc9-3cbfc80cf1ea",
      creation_timestamp: "2025-04-02T22:20:47.966448Z",
      role: "assistant",
      content:
        "The most popular music genre can vary depending on the region, demographics, and time period. Globally, as of the data up to 2023, **pop**, **hip-hop/rap**, and **rock** are among the most popular genres.\n\nHere is a general breakdown:\n\n1. **Pop**: Known for its catchy melodies and wide appeal, pop is often at the top of the charts globally.\n2. **Hip-hop/Rap**: Especially popular in countries like the United States, hip-hop has grown into a global phenomenon.\n3. **Rock**: Still a beloved genre, particularly classic and alternative rock, though its dominance has declined compared to past decades.\n4. **EDM (Electronic Dance Music)**: Thrives in clubs and festivals and enjoys massive popularity worldwide.\n5. **Latin**: Genres like reggaeton (e.g., Bad Bunny's music) have seen increased global success in recent years.\n6. **K-pop**: Korean pop music (e.g., BTS, BLACKPINK) has gained international fame and continues to grow in popularity.\n\nIf you're looking for popularity trends, recent surveys and platforms like Spotify or YouTube can often provide insights based on streaming numbers and audience engagement. Let me know if you'd like additional specifics!",
      file_name: null,
      file_type: null,
    },
    {
      id: "b3096ad1-d0d2-4baa-83f8-0c3b8597aad8",
      creation_timestamp: "2025-04-02T22:22:53.961042Z",
      role: "user",
      content: "no, Disco Polo is most popular",
      file_name: null,
      file_type: null,
    },
    {
      id: "d61df492-9cc4-4c82-a67d-69b82eee2ab5",
      creation_timestamp: "2025-04-02T22:23:02.413822Z",
      role: "assistant",
      content:
        "Thank you for pointing that out! **Disco Polo** is indeed a very popular music genre, especially in **Poland**, where it holds a unique cultural appeal. This genre combines simple, catchy melodies with dance beats and often features lyrics about love, happiness, and life. Disco Polo is particularly popular at weddings, festivals, and parties across the country.\n\nWhile globally genres like pop, hip-hop, or rock dominate, **Disco Polo has a massive fan base in Poland** and is considered one of the cultural staples there. Artists like **Akcent** (with Zenon Martyniuk), **Boys**, and **Czadoman** are among the most well-known in this genre.\n\nI appreciate you bringing this up—it highlights how cultural context plays a big role in music preferences!",
      file_name: null,
      file_type: null,
    },
  ],
  [
    {
      id: "f1909515-38cf-4d36-b653-03ca76e19230",
      creation_timestamp: "2025-06-05T13:08:42.964318Z",
      role: "assistant",
      content:
        "If 1 kg of apples costs $50, then 0.5 kg of apples would cost half of that amount.\n\n0.5 kg cost = 50$ × 0.5 = 25$\n\nSo, 0.5 kg of apples costs $25.",
      file_name: null,
      file_type: null,
    },
    {
      id: "a3ca18b4-e353-46d6-8472-9397625a9b7a",
      creation_timestamp: "2025-06-05T13:11:41.444722Z",
      role: "assistant",
      content:
        "Certainly! Here's a polished and clearer version of your message:\n\n---\n\nThis is very interesting. Almost half of the orders are under $50, with some large orders coming from commercial customers who might not have had accounts set up. Out of $795K in Indie Camper sales, $11K came from that segment. Additionally, 400 orders were under $10 — some even under $1. For example, there was an order of just $0.21.\n\nDo we currently have a minimum order amount to qualify for store delivery? \n\nIf we implemented a $50 minimum order, our sales would only decrease by $75K, but we would reduce the number of deliveries by 44%, which would translate to approximately $41K in delivery cost savings.\n\nI’m glad we could see the sales data to perform this analysis. Each store averages a benefit of about $250 per month, or $1,273 in total.\n\nI believe we should evaluate introducing either a minimum dollar order or a delivery charge. Chuck and I can put together some further analysis on this.\n\n---\n\nIf you want, I can help you draft a formal email version or adjust the tone further.",
      file_name: null,
      file_type: null,
    },
    {
      id: "bb80887c-060d-438b-9a70-77ea90dfbd35",
      creation_timestamp: "2025-06-05T13:14:12.267835Z",
      role: "assistant",
      content:
        "The formula for the area of a square is:\n\n\\[ \\text{Area} = s^2 \\]\n\nwhere \\( s \\) is the length of one side of the square.\n\nThe formula for the perimeter of a square is:\n\n\\[ \\text{Perimeter} = 4s \\]\n\nwhere \\( s \\) is the length of one side.",
      file_name: null,
      file_type: null,
    },
    {
      id: "ac6b9b65-c4b1-44c9-afee-b6e83f33c364",
      creation_timestamp: "2025-06-05T13:28:54.203221Z",
      role: "assistant",
      content:
        "It looks like your message has some formatting issues and repeated text. Here's a cleaned-up, clearer version based on what you provided:\n\n---\n\nThis is very interesting. Almost half of the orders are under $50, with some large orders coming from commercial customers who might not have had accounts set up. Out of $795K in Indie Camper sales, [please provide the rest of the data you want to include].\n\n---\n\nIf you provide more context or the rest of the sentence, I can help you complete and polish it further!",
      file_name: null,
      file_type: null,
    },
    {
      id: "996455ca-58d2-49aa-ad62-c547865dcd47",
      creation_timestamp: "2025-06-05T13:29:06.590567Z",
      role: "assistant",
      content:
        "Here is a polished and clear version of your sentence:\n\n---\n\nThis is very interesting. Almost half of the orders are under $50, with some large orders coming from commercial customers who might not have had accounts set up. Out of $795K in Indie Camper sales, [...]\n\n---\n\nIf you provide the rest of the information after “$795K in Indie,” I can help you complete the sentence.",
      file_name: null,
      file_type: null,
    },
    {
      id: "58088f76-586b-4761-bf73-ccd52348f7c7",
      creation_timestamp: "2025-06-05T13:29:31.645621Z",
      role: "assistant",
      content:
        'It seems like you\'re asking for a clear, corrected version of the phrase "return under 50, withsomelar." Based on context, I believe you meant:\n\n"return under $50, with some large..."\n\nIf you can provide more context or the full sentence, I can help craft a complete and polished version.',
      file_name: null,
      file_type: null,
    },
    {
      id: "799039f1-ca4c-4186-aec3-e68e9569837f",
      creation_timestamp: "2025-06-05T13:29:59.244129Z",
      role: "assistant",
      content:
        "It looks like your text got jumbled with letters spaced out. Here’s a clean, properly formatted version of what you wrote:\n\n---\n\nAlmost half of the orders are under $50, with some large orders coming from commercial customers who might not have had accounts set up. Out of [...]\n\n---\n\nIf you provide the remainder of the sentence, I can help you finish it smoothly.",
      file_name: null,
      file_type: null,
    },
    {
      id: "22b03c27-4d8d-4e17-986e-4d5a0a7a30ef",
      creation_timestamp: "2025-06-05T13:30:28.920762Z",
      role: "assistant",
      content:
        "Here is a cleaned-up and polished version of that fragment:\n\n---\n\nAlmost half of the orders are under $50, with some large orders from commercial customers who might not have had accounts set up. Out of $795K in [...]\n\n---\n\nIf you provide the rest, I can help complete the sentence.",
      file_name: null,
      file_type: null,
    },
    {
      id: "93911d48-11fe-4af7-9c5e-66d2a6dc82a6",
      creation_timestamp: "2025-06-05T13:30:42.172226Z",
      role: "assistant",
      content:
        'Certainly! Here\'s the corrected version of the text you provided:\n\n---\n\n"50, with some large orders from commercial customers who might not have had accounts set up. Out of"\n\n---\n\nIf you want, I can help you integrate this into a complete sentence or paragraph. Just let me know!',
      file_name: null,
      file_type: null,
    },
    {
      id: "95ffd20c-a968-4ce1-8fa4-3744f615317d",
      creation_timestamp: "2025-06-05T13:31:00.357671Z",
      role: "assistant",
      content:
        'Here\'s the cleaned-up and corrected version of your text fragment:\n\n"might not have had accounts set up. Out of $795K..."\n\nIf you provide the full sentence or more context, I can help you complete or polish it further!',
      file_name: null,
      file_type: null,
    },
    {
      id: "53d07ee3-5bc4-4dc6-a883-015b80f2b685",
      creation_timestamp: "2025-06-05T13:32:48.667252Z",
      role: "assistant",
      content:
        "Here’s a polished version of that fragment:\n\n“...$50, out of $795K...”\n\nIf you share more context or the full sentence, I can help complete it for you.",
      file_name: null,
      file_type: null,
    },
    {
      id: "b8a98372-5ffa-4c77-8d29-8141ed132ffe",
      creation_timestamp: "2025-06-05T14:35:10.610501Z",
      role: "assistant",
      content:
        "If you are asking what percentage $50 is of $100, the calculation is:\n\n\\[\n\\frac{50}{100} \\times 100\\% = 50\\%\n\\]\n\nSo, $50 is 50% of $100.",
      file_name: null,
      file_type: null,
    },
    {
      id: "188dd99b-ff6d-4267-acc9-1127c6fddd9f",
      creation_timestamp: "2025-06-09T11:23:23.271695Z",
      role: "assistant",
      content:
        'It looks like you want a clear, polished phrase from "50, oft 795K." Here’s a corrected version assuming you mean:\n\n“50, out of 795K”\n\nIf you provide more context or a full sentence, I can help complete it for you.',
      file_name: null,
      file_type: null,
    },
    {
      id: "9ba47753-341b-4891-97ef-e16b9f401ca6",
      creation_timestamp: "2025-06-09T11:24:15.753275Z",
      role: "assistant",
      content:
        'If you want to express "$50 of $100" as a percentage, it is:\n\n\\[\n\\frac{50}{100} \\times 100\\% = 50\\%\n\\]\n\nSo, $50 is 50% of $100. Let me know if you need it expressed differently!',
      file_name: null,
      file_type: null,
    },
    {
      id: "4b861b84-67c6-4a80-9cdd-f650ac1d3e48",
      creation_timestamp: "2025-06-10T11:00:41.364491Z",
      role: "assistant",
      content:
        "KaTeX supports a broad subset of LaTeX math syntax for rendering math expressions in web pages. Below is a list of **common KaTeX-supported syntax elements with examples** to help you understand what you can write and render using KaTeX.\n\n---\n\n## 1. **Basic Math**\n\n- **Fractions**\n  ```latex\n  \\frac{a}{b}\n  ```\n  *renders as* \\( \\frac{a}{b} \\)\n\n- **Square Roots & N-th Roots**\n  ```latex\n  \\sqrt{x}, \\sqrt[n]{x}\n  ```\n  *renders as* \\( \\sqrt{x}, \\sqrt[n]{x} \\)\n\n- **Superscripts and Subscripts**\n  ```latex\n  x^2, a_i\n  ```\n  *renders as* \\( x^2, a_i \\)\n\n- **Greek Letters**\n  ```latex\n  \\alpha, \\beta, \\gamma, \\Delta\n  ```\n  *renders as* \\( \\alpha, \\beta, \\gamma, \\Delta \\)\n\n---\n\n## 2. **Operators and Relations**\n\n- **Sum and Integral**\n  ```latex\n  \\sum_{i=1}^n i, \\int_0^\\infty e^{-x} dx\n  ```\n  *renders as* \\( \\sum_{i=1}^n i, \\int_0^\\infty e^{-x} dx \\)\n\n- **Limits**\n  ```latex\n  \\lim_{x \\to 0} \\frac{\\sin x}{x}\n  ```\n  *renders as* \\( \\lim_{x \\to 0} \\frac{\\sin x}{x} \\)\n\n- **Products**\n  ```latex\n  \\prod_{i=1}^n i\n  ```\n  *renders as* \\( \\prod_{i=1}^n i \\)\n\n- **Set Notations**\n  ```latex\n  \\infty, \\forall, \\exists, \\emptyset\n  ```\n  *renders as* \\( \\infty, \\forall, \\exists, \\emptyset \\)\n\n---\n\n## 3. **Delimiters**\n\n- **Brackets & Parentheses**\n  ```latex\n  (x), [x], \\{x\\}, \\langle x \\rangle\n  ```\n  *renders as* \\( (x), [x], \\{x\\}, \\langle x \\rangle \\)\n\n- **Adjustable Size Delimiters**\n  ```latex\n  \\left( \\frac{a}{b} \\right), \\left[ \\sum_i x_i \\right]\n  ```\n  *renders as* \\( \\left( \\frac{a}{b} \\right), \\left[ \\sum_i x_i \\right] \\)\n\n---\n\n## 4. **Functions**\n\n- **Trigonometric**\n  ```latex\n  \\sin x, \\cos x, \\tan x\n  ```\n  *renders as* \\( \\sin x, \\cos x, \\tan x \\)\n\n- **Logarithms and Exponentials**\n  ```latex\n  \\log x, \\ln x, \\exp x\n  ```\n  *renders as* \\( \\log x, \\ln x, \\exp x \\)\n\n- **Other Functions**\n  ```latex\n  \\sqrt{x}, \\max, \\min, \\arg, \\deg\n  ```\n  *renders as* \\( \\sqrt{x}, \\max, \\min, \\arg, \\deg \\)\n\n---\n\n## 5. **Accents**\n\n- **Hat, Tilde, Bar, Vector**\n  ```latex\n  \\hat{x}, \\tilde{x}, \\bar{x}, \\vec{x}\n  ```\n  *renders as* \\( \\hat{x}, \\tilde{x}, \\bar{x}, \\vec{x} \\)\n\n- **Dots**\n  ```latex\n  \\dot{x}, \\ddot{x}\n  ```\n  *renders as* \\( \\dot{x}, \\ddot{x} \\)\n\n---\n\n## 6. **Text**\n\n- **Adding Text in Math Mode**\n  ```latex\n  \\text{Hello}\n  ```\n  *renders as* \\( \\text{Hello} \\)\n\n---\n\n## 7. **Matrices and Arrays**\n\n- **Matrices**\n  ```latex\n  \\begin{matrix} a & b \\\\ c & d \\end{matrix}\n  ```\n  *renders as* \n  \\[\n  \\begin{matrix} a & b \\\\ c & d \\end{matrix}\n  \\]\n\n- **Parenthesized Matrices**\n  ```latex\n  \\begin{pmatrix} 1 & 0 \\\\ 0 & 1 \\end{pmatrix}\n  ```\n  *renders as* \n  \\[\n  \\begin{pmatrix} 1 & 0 \\\\ 0 & 1 \\end{pmatrix}\n  \\]\n\n---\n\n## 8. **Align and Equation Environments**\n\n- **Aligned Equations**\n  ```latex\n  \\begin{align}\n  a &= b + c \\\\\n  d &= e + f\n  \\end{align}\n  ```\n  *renders as aligned math*\n\n---\n\n## 9. **Limits and Sums with Subscripts**\n\n- Using subscript and superscript notation in sums and limits.\n  ```latex\n  \\sum_{k=0}^\\infty \\frac{1}{k!} = e\n  ```\n  *renders as* \\( \\sum_{k=0}^\\infty \\frac{1}{k!} = e \\)\n\n---\n\n## 10. **Logical Symbols**\n\n```latex\n\\land, \\lor, \\neg, \\Rightarrow, \\Leftrightarrow\n```\n*renders as* \\( \\land, \\lor, \\neg, \\Rightarrow, \\Leftrightarrow \\)\n\n---\n\n# Additional notes:\n\n- KaTeX supports **most** of LaTeX math, but **not everything**. (For example, some very specialized packages or environments are unsupported.)\n- For full details, see the [KaTeX Supported Functions documentation](https://katex.org/docs/supported.html).\n\n---\n\nIf you want, I can provide ready-to-use KaTeX example snippets for any of these or more advanced math!",
      file_name: null,
      file_type: null,
    },
  ],
];
